import clsx from "clsx";
import type { ReactNode } from "react";

export type BadgeTone =
  | "neutral"
  | "brand"
  | "info"
  | "success"
  | "warning"
  | "danger";

const TONES: Record<BadgeTone, string> = {
  neutral: "bg-surface-alt text-ink",
  brand: "bg-goldenrod text-ink",
  info: "bg-viking text-blue-dianne",
  success: "bg-leaf text-white",
  warning: "bg-carrot-orange text-white",
  danger: "bg-sunset-orange text-white",
};

export default function Badge({
  tone = "neutral",
  children,
  className,
  // A badge is often the short name for something that needs a sentence. Two
  // callers were already passing this and silently having it dropped.
  title,
}: {
  tone?: BadgeTone;
  children: ReactNode;
  className?: string;
  title?: string;
}) {
  return (
    <span
      title={title}
      className={clsx(
        "border-line font-display text-caption inline-flex items-center gap-1.5 rounded-full border px-3 py-0.5 font-bold",
        TONES[tone],
        className,
      )}
    >
      {children}
    </span>
  );
}
